import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

type TypographyVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'overline';
type TypographyColor = 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'default' | 'muted';
type TypographyAlign = 'left' | 'center' | 'right' | 'justify';
type TypographyWeight = 'light' | 'normal' | 'medium' | 'semibold' | 'bold';

@Component({
  selector: 'app-typography',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './typography.component.html',
  styleUrls: ['./typography.component.scss']
})
export class TypographyComponent {
  @Input() variant: TypographyVariant = 'body1';
  @Input() color: TypographyColor = 'default';
  @Input() align: TypographyAlign = 'left';
  @Input() weight: TypographyWeight = 'normal';
  @Input() gutterBottom: boolean = false;
  @Input() noWrap: boolean = false;
  @Input() truncate: boolean = false;
  @Input() uppercase: boolean = false;
  @Input() lowercase: boolean = false;
  @Input() capitalize: boolean = false;
  @Input() italic: boolean = false;
  @Input() underline: boolean = false;
  @Input() lineThrough: boolean = false;
  @Input() className: string = '';

  get element(): string {
    switch (this.variant) {
      case 'h1': return 'h1';
      case 'h2': return 'h2';
      case 'h3': return 'h3';
      case 'h4': return 'h4';
      case 'h5': return 'h5';
      case 'h6': return 'h6';
      case 'subtitle1':
      case 'subtitle2': return 'h6';
      case 'body1':
      case 'body2': return 'p';
      case 'caption':
      case 'overline': return 'span';
      default: return 'p';
    }
  }

  get classes(): string {
    const classes = [
      'typography',
      `typography-${this.variant}`,
      `typography-${this.color}`,
      `text-${this.align}`,
      `font-${this.weight}`
    ];

    if (this.gutterBottom) classes.push('gutter-bottom');
    if (this.noWrap) classes.push('no-wrap');
    if (this.truncate) classes.push('truncate');
    if (this.uppercase) classes.push('uppercase');
    if (this.lowercase) classes.push('lowercase');
    if (this.capitalize) classes.push('capitalize');
    if (this.italic) classes.push('italic');
    if (this.underline) classes.push('underline');
    if (this.lineThrough) classes.push('line-through');
    if (this.className) classes.push(this.className);

    return classes.join(' ');
  }
}